import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

type fn = (...args: any[]) => void;
type Event = MouseEvent | TouchEvent;

export const useOutsideClick = (callback: fn, params?: any, secondRef?: any): MutableRefObject<any> => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (event: Event): void => {
      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        (!secondRef || !secondRef.current.contains(event.target))
      ) {
        callback(params);
      }
    };
    document.addEventListener('mousedown', handleClick, true);
    document.addEventListener('touchstart', handleClick, true);

    return () => {
      document.removeEventListener('mousedown', handleClick, true);
      document.removeEventListener('touchstart', handleClick, true);
    };
  }, [ref, callback]);

  return ref;
};
